module.exports = __webpack_public_path__ + "6013cb32.png";